module.exports = __webpack_public_path__ + "img/logo.8d57d4a1.png";